import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["childNodeIds"];
import { immerable } from 'immer';
import GridNode from './GridNode';
import { GRID_NODE_TYPES } from './constants';
import { mergeIntoPath } from './utils';
export default class SectionNode extends GridNode {
  constructor(_ref) {
    let {
        childNodeIds = []
      } = _ref,
      sectionNodeParams = _objectWithoutPropertiesLoose(_ref, _excluded);
    super(sectionNodeParams);
    this[immerable] = true;
    this._childNodeIds = childNodeIds;
  }
  cloneAndChange(sectionNodeParams) {
    const {
      id,
      childNodeIds,
      parentNodeId,
      value,
      treeRef
    } = sectionNodeParams;
    const newNodeParams = {
      id: id !== null && id !== void 0 ? id : this._id,
      type: GRID_NODE_TYPES.SECTION,
      treeRef: treeRef !== null && treeRef !== void 0 ? treeRef : this._treeRef,
      childNodeIds: childNodeIds !== null && childNodeIds !== void 0 ? childNodeIds : this._childNodeIds,
      parentNodeId: parentNodeId !== null && parentNodeId !== void 0 ? parentNodeId : this._parentNodeId,
      value: value !== null && value !== void 0 ? value : this._value
    };
    return newNodeParams.treeRef.createNewSection(newNodeParams);
  }
  exportNode() {
    return {
      id: this.getId(),
      value: this.getValue(),
      parentNodeId: this.getParentNodeId(),
      childNodeIds: [...this.getChildNodeIds()]
    };
  }
  getChildNodes() {
    return this.getChildNodeIds().map(childNodeId => this.getTree().findNode(childNodeId));
  }
  mergeIntoValue(partialValue, path) {
    return this.cloneAndChange({
      value: mergeIntoPath(this._value, partialValue, path)
    });
  }
  mergeIntoStyles(partialStyles, path) {
    return this.cloneAndChange({
      value: Object.assign({}, this._value, {
        styles: mergeIntoPath(this._value.styles, partialStyles, path)
      })
    });
  }
  getBreakpointStyles(breakpoint = 'default') {
    const defaultStyles = Object.assign({}, this._value.styles.breakpointStyles.default);
    if (breakpoint !== 'default') {
      return Object.assign({}, defaultStyles, this._value.styles.breakpointStyles[breakpoint]);
    }
    return defaultStyles;
  }
}